import { formatDate, parseDate } from '../../utils/dateUtils';
import { TextCell } from './TextCell';

export const DateCell = ({
    dateString,
    placeholder = '',
    disabled,
}: {
    dateString?: string;
    placeholder?: string | null;
    disabled?: boolean;
}) => (
    <TextCell value={dateString && formatDate(parseDate(dateString))} placeholder={placeholder} disabled={disabled} />
);
